import { NumberOrNullOrUndefined, StringOrNullOrUndefined } from 'src/app/shared/utils';

export class RbtByPlanReport {
  id: number | null;
  name: string | null;
  surname: string | null;

  constructor(data: Partial<RbtByPlanReport> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? null;
    this.name = StringOrNullOrUndefined(data.name) ?? null;
    this.surname = StringOrNullOrUndefined(data.surname) ?? null;
  }
}

export class ReportClientRbtNotesByPlan {
  id: number | null;
  full_name: string | null;
  rbt_home: RbtByPlanReport | null;
  rbt2_school: RbtByPlanReport | null;
  notes_count: number | null;

  constructor(data: Partial<ReportClientRbtNotesByPlan> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? null;
    this.full_name = StringOrNullOrUndefined(data.full_name) ?? null;
    this.rbt_home = data.rbt_home ? new RbtByPlanReport(data.rbt_home) : null;
    this.rbt2_school = data.rbt2_school ? new RbtByPlanReport(data.rbt2_school) : null;
    this.notes_count = NumberOrNullOrUndefined(data.notes_count) ?? null;
  }
}





